import React, {Fragment, useState} from "react";
import {Popover, Transition} from "@headlessui/react";
import {t} from "i18next";
import {useAuth} from "../hooks/useAuth";
import Cookies from "universal-cookie";

export const FlyoutOthersMenu = (props) => {
	const {isAuthenticated} = useAuth();

	const optionsData = [
		{
			title: t("HEADER.OTHER_MENU.2010_GRANTH.TITLE"),
			description: t("HEADER.OTHER_MENU.2010_GRANTH.DESCRIPTION"),
			icon: "/assets/granth-icon-outlined.svg",
			hoverIcon: "/assets/granth-icon-filled.svg",
			url: "https://jogkulstorageuat.blob.core.windows.net/siteassets/myFolder/joglekar_kulvrutant_2010.pdf",
			authenticationRequired: true
		},
		// {
		//     title: t("HEADER.OTHER_MENU.PHOTO_GALLERY.TITLE"),
		//     description: t("HEADER.OTHER_MENU.PHOTO_GALLERY.DESCRIPTION"),
		//     icon: "/assets/photo-gallery-icon-outlined.svg",
		//     hoverIcon: "/assets/photo-gallery-icon-filled.svg",
		//     url: '/photo-gallery',
		//     authenticationRequired: true
		// },
		{
			title: t("HEADER.OTHER_MENU.MEMORIES.TITLE"),
			description: t("HEADER.OTHER_MENU.MEMORIES.DESCRIPTION"),
			icon: "/assets/memories-icon-outlined.svg",
			hoverIcon: "/assets/memories-icon-filled.svg",
			url: '/memories',
			authenticationRequired: true
		},
		{
			title: t("HEADER.OTHER_MENU.BEST_WISHES.TITLE"),
			description: t("HEADER.OTHER_MENU.BEST_WISHES.DESCRIPTION"),
			icon: "/assets/best-wishes-icon-outlined.svg",
			hoverIcon: "/assets/best-wishes-icon-filled.svg",
			url: '/best-wishes',
			authenticationRequired: true
		},
		{
			title: t("HEADER.OTHER_MENU.REMEMBRANCE_DAY.TITLE"),
			description: t("HEADER.OTHER_MENU.REMEMBRANCE_DAY.DESCRIPTION"),
			icon: "/assets/remembrance-day-icon-outlined.svg",
			hoverIcon: "/assets/remembrance-day-icon-filled.svg",
			url: '/remembrance-day',
			authenticationRequired: true
		},

		{
			title: t("HEADER.OTHER_MENU.PRIDE.TITLE"),
			description: t("HEADER.OTHER_MENU.PRIDE.DESCRIPTION"),
			icon: "/assets/pride-icon-outlined.svg",
			hoverIcon: "/assets/pride-icon-filled.svg",
			url: '/pride',
			authenticationRequired: false
		},
		{
			title: t("HEADER.OTHER_MENU.ANUROOP_JODIDAR.TITLE"),
			description: t("HEADER.OTHER_MENU.ANUROOP_JODIDAR.DESCRIPTION"),
			icon: "/assets/anuroop-jodidar-icon-outlined.svg",
			hoverIcon: "/assets/anuroop-jodidar-icon-filled.svg",
			url: '/anuroop-jodidar',
			authenticationRequired: true
		},
		{
			title: t("HEADER.OTHER_MENU.NEWS_EVENTS.TITLE"),
			description: t("HEADER.OTHER_MENU.NEWS_EVENTS.DESCRIPTION"),
			icon: "/assets/news-and-events-icon-outlined.svg",
			hoverIcon: "/assets/news-and-events-icon-filled.svg",
			url: '/news-and-events',
			authenticationRequired: true
		},
		{
			title: t("HEADER.OTHER_MENU.HAPPY_TO_SHARE.TITLE"),
			description: t("HEADER.OTHER_MENU.HAPPY_TO_SHARE.DESCRIPTION"),
			icon: "/assets/happy-to-share-icon-outlined.svg",
			hoverIcon: "/assets/happy-to-share-icon-filled.svg",
			url: '/happy-to-share',
			authenticationRequired: true
		}
	];

	const {isFlyoutOthersMenuOpen, setIsFlyoutOthersMenuOpen, setIsFlyoutNavigationMenuOpen} = props;
	const [isFlyoutOthersMenuButtonHovered, setIsFlyoutOthersMenuButtonHovered] = useState(false);

	const [hoveredOptionIndex, setHoveredOptionIndex] = useState(null);

	return (
		<div
			className={`portrait:jk:hidden landscape:md:hidden h-fit py-[0.75rem]
                ${isFlyoutOthersMenuButtonHovered && 'bg-black/30'} 
                flex items-center justify-center
                transition ease-in-out duration-150
                relative after:content-[''] after:absolute
                after:right-0 after:bottom-0 after:left-0 after:h-[1.5px] after:bg-[length:10px_1px]
                after:bg-[linear-gradient(90deg,#EEEEE2,#EEEEE2_50%,transparent_0,transparent)]`}
		>
			<Popover className="flex w-full">
				{({}) => {
					// To prevent the body from scrolling when the popover is isFlyoutOthersMenuOpen
					document.body.classList.toggle(
						"overflow-y-hidden",
						isFlyoutOthersMenuOpen
					);

					return (
						<>
							<button
								onMouseEnter={() => setIsFlyoutOthersMenuButtonHovered(true)}
								onMouseLeave={() => setIsFlyoutOthersMenuButtonHovered(false)}
								onClick={() => setIsFlyoutOthersMenuOpen(!isFlyoutOthersMenuOpen)}
								className="arrow-button flex-1 flex items-center justify-between outline-none w-full"
							>
								<p
									className="font-custom-semi-bold text-gray-900
                                    portrait:text-[1.1rem] portrait:sm:text-[1.3rem]
                                    landscape:text-[1.15rem] landscape:sm:text-[1.25rem]"
								>
									{t("HEADER.OTHER_MENU.TITLE")}
								</p>
								<svg
									viewBox="0 0 6 6"
									fill="none"
									id={"arrow-icon"}
									className="aspect-auto
                                    portrait:h-[0.85rem] portrait:sm:h-[1.1rem]
                                    landscape:h-[0.75rem] landscape:sm:h-[0.95rem]"
									xmlns="http://www.w3.org/2000/svg"
								>
									<path
										d="M3 1L5 3L3 5"
										id={"arrow-icon-tip"}
										stroke="#111827"
										strokeLinecap="square"
									/>
									<path
										d="M1 3L4 3"
										id={"arrow-icon-line"}
										stroke="#111827"
										strokeLinecap="square"
									/>
								</svg>
							</button>

							<Transition
								show={isFlyoutOthersMenuOpen}
								as={Fragment}
								enter="transition ease-out duration-300"
								enterFrom="opacity-0 translate-x-full"
								enterTo="opacity-100 translate-x-0"
								leave="transition ease-in duration-200"
								leaveFrom="opacity-100 translate-x-0"
								leaveTo="opacity-0 translate-x-full"
							>
								<Popover.Panel
									className="fixed z-[10000] flex flex-col bottom-0 left-0
                                    min-w-screen min-h-[100dvh] w-screen h-[100dvh] max-w-screen max-h-[100dvh]"
								>
									<div
										className="flex flex-col items-center justify-center
                                        h-full w-full bg-white overflow-hidden"
									>
										{/* Header */}
										<div
											className="w-full flex items-center justify-between
                                                portrait:py-[0.5rem] portrait:pl-[1.25rem] portrait:pr-[0.75rem]
                                                portrait:sm:py-[0.75rem] portrait:sm:pl-[1rem] portrait:sm:pr-[0.5rem]
                                                portrait:gap-x-[0.5rem] portrait:sm:gap-x-[0.75rem]
                                                landscape:py-[0.75rem] landscape:pl-[1rem] landscape:pr-[0.75rem]
                                                landscape:gap-x-[0.5rem] landscape:sm:gap-x-[0.75rem]
                                                relative after:content-[''] after:absolute
                                                after:right-0 after:bottom-0 after:left-0 after:h-[1px] after:bg-[length:17px_1px]
                                                after:bg-[linear-gradient(90deg,#EEEEE2,#EEEEE2_50%,transparent_0,transparent)]"
										>
											{/* Back Button */}
											<button
												onClick={() => setIsFlyoutOthersMenuOpen(false)}
												className="flex items-center
                                                    portrait:gap-x-[0.75rem] portrait:sm:gap-x-[0.75rem]
                                                    landscape:gap-x-[0.5rem] landscape:sm:gap-x-[0.75rem]"
											>
												<svg
													viewBox="0 0 108 176"
													fill="none"
													xmlns="http://www.w3.org/2000/svg"
													className="aspect-square
                                                        portrait:h-[0.75rem] portrait:sm:h-[0.95rem]
                                                        landscape:h-[0.75rem] landscape:sm:h-[0.95rem]"
												>
													<path
														d="M88 156L20 88L88 20" stroke="#111827"
														strokeWidth="30"
														strokeLinecap="round"
														strokeLinejoin="round"
													/>
												</svg>

												<h1
													key="back-to-main-menu"
													className="flex font-custom-bold text-gray-900 leading-tight
                                                    portrait:text-[1.2rem] portrait:sm:text-[1.5rem]
                                                    landscape:text-[1.1rem] landscape:sm:text-[1.5rem]"
												>
													{t("HEADER.BACK")}
												</h1>
											</button>

											{/* Close Icon */}
											<button
												onClick={() => {
													setIsFlyoutOthersMenuOpen(false);
													setTimeout(() => {
														setIsFlyoutNavigationMenuOpen(false);
													}, 200);
												}}
												type="button"
												className="flex items-center justify-center rounded-lg
                                                    portrait:h-[2rem] portrait:sm:h-[2.5rem]
                                                    landscape:h-[1.5rem] landscape:sm:h-[2.25rem]
                                                    aspect-square bg-transparent hover:bg-gray-200"
											>
												<img
													className={"h-[85%] aspect-square"}
													src={"/assets/close-icon-dark.svg"}
													alt={"Close"}
													title={"Close"}
												/>
											</button>
										</div>

										{/* Navigation Links */}
										<div
											className="h-full w-full flex-1 flex flex-col overflow-y-auto"
										>
											{optionsData.map((option, index) => (
												<button
													key={index}
													onClick={() => {
														if (option.authenticationRequired && !isAuthenticated) {
															new Cookies().set("authRequired", true, {path: '/'});
															window.open('/login', '_self');
														} else {
															window.open(option.url, '_blank');
														}
													}}
												>
													<div
														className={`group flex 
                                                            ${hoveredOptionIndex === index && 'bg-gray-200'}
                                                            transition duration-150 ease-[cubic-bezier(0.215,0.61,0.355,1)]
                                                            portrait:py-[0.75rem] portrait:px-[1.25rem]
                                                            landscape:py-[0.75rem] landscape:px-[1.25rem]
                                                            portrait:gap-x-[1rem] landscape:gap-x-[1rem]
                                                            relative after:content-[''] after:absolute
                                                            after:right-0 after:bottom-0 after:left-0
                                                            after:h-[1.5px] after:bg-[length:10px_1px]
                                                            after:bg-[linear-gradient(90deg,#EEEEE2,#EEEEE2_50%,transparent_0,transparent)]`}
														onMouseEnter={() => setHoveredOptionIndex(index)}
														onMouseLeave={() => setHoveredOptionIndex(null)}
														onTouchStart={() => setHoveredOptionIndex(index)}
														onTouchEnd={() => setHoveredOptionIndex(null)}
													>
														<div
															className={`flex items-center justify-center
                                                                portrait:h-[3rem] portrait:sm:h-[3.5rem]
                                                                portrait:p-[0.75rem] portrait:sm:p-[1rem]
                                                                landscape:h-[3rem] landscape:sm:h-[4.25rem]
                                                                landscape:p-[0.75rem] landscape:sm:p-[1.25rem] 
                                                                aspect-square rounded-xl
                                                                ${hoveredOptionIndex === index ? 'bg-orange-400' : 'bg-gray-50'}
                                                                transition duration-150 ease-[cubic-bezier(0.215,0.61,0.355,1)]`}
														>
															<img
																alt={option.title}
																src={hoveredOptionIndex === index ? option.hoverIcon : option.icon}
																className="h-full aspect-square"
															/>
														</div>
														<div className={"flex flex-col"}>
															<h1
																className="font-custom-semi-bold leading-tight text-gray-900
                                                                portrait:text-[1rem] portrait:sm:text-[1.25rem]
                                                                landscape:text-[1rem] landscape:sm:text-[1.25rem] text-left"
															>
																{option.title}
															</h1>
															<p
																className="max-w-[75dvw] mt-1
                                                                font-custom-regular leading-tight text-gray-700
                                                                portrait:text-[0.85rem] portrait:sm:text-[1rem]
                                                                landscape:text-[0.85rem] landscape:sm:text-[1rem] text-left"
															>
																{option.description}
															</p>
														</div>
													</div>
												</button>
											))}
										</div>
									</div>
								</Popover.Panel>
							</Transition>
						</>
					);
				}}
			</Popover>
		</div>
	)
}
